import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_heading = _resolveComponent("base-heading")

  return (_openBlock(), _createBlock(_component_base_heading, {
    class: "_flex _gap-1 _ai-c",
    tag: $props.tag
  }, {
    default: _withCtx(() => [
      ($props.iconName)
        ? (_openBlock(), _createBlock(_component_base_icon, {
            key: 0,
            name: $props.iconName,
            "icon-namespace": $props.iconNamespace,
            "aria-hidden": "true"
          }, null, 8 /* PROPS */, ["name", "icon-namespace"]))
        : _createCommentVNode("v-if", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["tag"]))
}